import { SpwkUtilV3 } from "../dao/SpwkUtilV3";
import { HisBasic } from "./HisBasic";
import { HisRow, SpwkHisStep } from "./HisRow";
import { SpwkMetaTable } from "./SpwkMetaTable";

export class HisRowParser_檢查時期 {

  static ConvertToHisRow(step: SpwkHisStep, func_code: string, his_basic: HisBasic, meta_table: SpwkMetaTable): HisRow {
    if (step.Chapter !== SpwkUtilV3.CHAPTER_檢查時期) {
      throw new Error("必須是 檢查時期 !!!");
    }

    const data_row: HisRow = new HisRow(his_basic, step.HIS類別代碼);


    // 1新進、2定期、3變更、4追蹤
    const his_code = meta_table.Get檢查時期HisCode(func_code);


    data_row.項目 = "1";
    data_row.結果 = his_code;

    return data_row;
  }

}